//Material ui
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";

//Context
import { useSettings } from "Context/Settings/useSettings";

//Iconos
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const DialogDecisions = ( ) => {
    const settings = useSettings()

    //Confirmacion de cierre en el modal
    const redirectVisit = (status: boolean) => {

        if (settings.dialog.callBack ) settings.dialog.callBack()

        if ( status && settings.dialog.callBackSuccess ) settings.dialog.callBackSuccess()
        if ( !status && settings.dialog.callBackDenied ) settings.dialog.callBackDenied()


        settings.setDialog((prev)=> ({ ...prev, open: false }))

        // context.assignateAnswer(exit)
        // context.assignateOpen(false)

        // //Valida cuando se quiera cancelar la orden
        // if (props.cancelOrder === true && exit) {
        //     context.assignateClientList([])

        //     //Resetea la factura
        //     context.assignateBill({
        //         cardCode: "",
        //         cardFName: "",
        //         cardName: "",
        //         typeDocument: "",
        //         documentNumber: 0,
        //         typePayment: "",
        //         nameEmployee: "",
        //         dateExpired: "",
        //         PymntGroup: "",
        //         extraDays: 0,
        //         timeExpired: 0,
        //         priceList: 0,
        //         salesPersonCode: 0,
        //         notes: "",
        //         municipality: {
        //             id: "",
        //             label: ""
        //         },
        //         departament: {
        //             id: "",
        //             label: ""
        //         },
        //         phoneNumber: "",
        //         email: "",
        //         giro: {
        //             id: "",
        //             label: ""
        //         },
        //         WTLiable: "",
        //         nit: "",
        //         nrc: "",
        //         u_type: "",
        //         exentIVA: false,
        //         documentDate: "",
        //         documentDateConta: "",
        //         documentDateExpiration: "",
        //         products: [],
        //         detailBill: undefined
        //     })
        //     context.assignateCopyData(undefined)

        //     navigate(-1)
        // } else {
        //     if (props.setAnswer !== undefined) {
        //         props.setAnswer(exit)
        //     }
        //     props.setClose(false);

        // }
    }

    //Cierra el dialogo
    const hiddenDialog = () => {

        // if (props.quantity) {
        //     if (props.cancelOrder) {
        //         context.assignateClientList([])

        //         //Resetea la factura
        //         context.assiganteProdcutsBills([])
        //         context.assignateDateDocument("")
        //         context.assignateDetailBill({})

        //         context.assignateBill({
        //             cardCode: "",
        //             cardFName: "",
        //             cardName: "",
        //             typeDocument: "",
        //             documentNumber: 0,
        //             typePayment: "",
        //             nameEmployee: "",
        //             dateExpired: "",
        //             PymntGroup: "",
        //             extraDays: 0,
        //             timeExpired: 0,
        //             priceList: 0,
        //             salesPersonCode: 0,
        //             notes: "",
        //             municipality: {
        //                 id: "",
        //                 label: ""
        //             },
        //             departament: {
        //                 id: "",
        //                 label: ""
        //             },
        //             phoneNumber: "",
        //             email: "",
        //             WTLiable: "",
        //             giro: {
        //                 id: "",
        //                 label: ""
        //             },
        //             nit: "",
        //             nrc: "",
        //             u_type: "",
        //             exentIVA: false,
        //             documentDate: "",
        //             documentDateConta: "",
        //             documentDateExpiration: "",
        //             products: [],
        //             detailBill: undefined
        //         })
        //         context.assignateCopyData(undefined)
        //     }
        //     navigate(props.quantity)
        //     return
        // }

        // if (props.redirect) {
        //     navigate(-1)
        // }
        // props.setClose(false);
    }


    const openModalPrint = (typeParams:'b64' | 'print') => {
        // setType(typeParams)
        // setOpenBill(true)
    }

    //Renderizado
    return (
        <Dialog open={settings.dialog.open} className="card-confirmation">
            {/* <BillPrint 
                idBill={ props.documentId ?? 0 }
                typeDocument={ props.typeDocument ?? "TIC" }
                type={ type }
                open={ openBill }
                setOpen={ setOpenBill } /> */}
            <DialogTitle className="title-card">
                {settings.dialog.title}
            </DialogTitle>
            <DialogContent>
                <p>{ settings.dialog.message}</p>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
                {/* {props.messageInformation ?
                    <div style={{ margin:"auto", textAlign:"center", }}>
                        <Button
                            size="small"
                            variant="accept-button"
                            onClick={hiddenDialog}>
                            Aceptar
                        </Button>
                        {
                            props.print && (props.typeDocument === "TKT" || props.typeDocument === "TIC" || props.typeDocument === "COF" || props.typeDocument === "CRF") &&
                            <div className="btn-card-print" style={{ marginTop:"20px" }}>
                                <Button
                                    size="small"
                                    variant="submit-button"
                                    onClick={() => openModalPrint('print')}
                                    endIcon={<ReceiptLongIcon />}>
                                    Imprimir factura
                                </Button>
                                 <Button
                                    size="small"
                                    variant="submit-button"
                                    onClick={() => openModalPrint('b64')}
                                    endIcon={<ReceiptIcon />}>
                                    Visualizar factura
                                </Button>
                            </div>
                        }
                    </div> 
                    : */}
                        <Button
                            size="small"
                            variant="accept-button"
                            sx={{ width: "110px" }}
                            endIcon={<CheckIcon />}
                            onClick={() => { redirectVisit(true) }}>
                            Si
                        </Button>
                        <Button
                            size="small"
                            variant="cancel-button"
                            sx={{ width: "110px" }}
                            endIcon={<CloseIcon />}
                            onClick={() => { redirectVisit(false) }}>
                            No
                        </Button>
                {/* } */}
            </DialogActions>
        </Dialog>
    )
}

export default DialogDecisions;